export const LOCAL_STORAGE_KEY__LOCALE = 'locale';
export const LOCAL_STORAGE_KEY__ACCESS_TOKEN = 'access_token';
